import React from "react";
import { DatePicker, DateTimePicker } from "material-ui-pickers";
import { ValidatorComponent } from "react-material-ui-form-validator";
import moment from 'moment';

class Picker extends ValidatorComponent {
    handleDateChange = format => date => {
        if(date){
            if(date instanceof moment){
                this.props.onChange(date);
            }else if(moment(date.target.value, format, true).isValid()){
                this.props.onChange(moment(date.target.value, format, true));
            }
        }else{
            this.props.onChange(null);
        }
    };

  render() {
    const {
      errorMessages,
      validators,
      requiredError,
      helperText,
      validatorListener,
      dateOnly,
        value,
      ...rest
    } = this.props;
    const { isValid } = this.state;
    if(dateOnly){
        return (
            <DatePicker
                {...rest}
                clearable={true}
                onChange={this.handleDateChange(this.props.format)}
                onInputChange={this.handleDateChange(this.props.format)}
                keyboard
                invalidLabel=" "
                disableOpenOnEnter
                animateYearScrolling={false}
                error={!isValid}
                helperText={(!isValid && this.getErrorMessage()) || helperText}
                value={(value === "" || value === null) ? null : value}
                mask={[
                    /\d/,
                    /\d/,
                    '/',
                    /\d/,
                    /\d/,
                    '/',
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                ]}

            />
        );
    }else{
        return (
            <DateTimePicker
                {...rest}
                ampm={false}
                clearable={true}
                onChange={this.handleDateChange(this.props.format)}
                onInputChange={this.handleDateChange(this.props.format)}
                keyboard
                invalidLabel=" "
                disableOpenOnEnter
                animateYearScrolling={false}
                error={!isValid}
                helperText={(!isValid && this.getErrorMessage()) || helperText}
                value={(value === "" || value === null) ? null : value}
                mask={[
                    /\d/,
                    /\d/,
                    '/',
                    /\d/,
                    /\d/,
                    '/',
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    ' ',
                    /\d/,
                    /\d/,
                    ':',
                    /\d/,
                    /\d/,
                ]}
            />
        );
    }
  }
}

export default Picker;



// WEBPACK FOOTER //
// ./src/component/utils/Picker.js